import { render, staticRenderFns } from "./Periodes.vue?vue&type=template&id=054d9748&"
import script from "./Periodes.vue?vue&type=script&lang=js&"
export * from "./Periodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports